import Venue from "../../../../src/components/Home/Venue";
import * as React from 'react';
export default {
  Venue,
  React
};